import RangeField from './component';
import { RangeFieldProps } from './types';

export type { RangeFieldProps };
export default RangeField;
